/* Video de la sección "Cómo funciona"
   ──────────────────────────────────────────────────────────────────────────
   Arranca solo cuando la sección entra en pantalla, en silencio, y se puede
   activar el sonido con el botón del parlante.

   LO QUE ESTE ARCHIVO CUIDA ES EL TRÁFICO
   El video vive abajo del todo en la portada. La mayoría de la gente que abre
   bactoboost.cl en el teléfono no llega nunca hasta ahí, y bajarle un mp4 a
   quien no lo va a ver es gastarle los datos y la batería. Por eso el video
   sale del servidor con `preload="none"` —cero bytes al cargar la página— y
   este archivo lo va soltando por etapas:

     1. La persona se acerca a menos de 300 px de la sección → recién ahí se
        elige la versión del archivo y se empieza a bajar.
     2. La sección ocupa el 40% de la pantalla → se reproduce.
     3. Se va de la sección o cambia de pestaña → se pausa.

   QUÉ VERSIÓN DEL ARCHIVO SE BAJA
   Shopify guarda cada video en varias resoluciones. El navegador no elige: se
   queda con el primer `<source>` que sepa leer, así que un teléfono que muestra
   el video en 255 px de ancho se bajaba igual la versión más grande. Acá se
   mide la caja de verdad y se pide la versión más chica que la cubra.
   En Safari y iOS no hace falta: Shopify entrega también un HLS, que va
   ajustando la calidad a la red solo, y ese va primero en el HTML.

   POR QUÉ NO EL ATRIBUTO `autoplay`
   Con `autoplay` el video empieza al cargar la página aunque esté tres
   pantallas más abajo. `IntersectionObserver` lo arranca cuando la persona
   efectivamente llegó, que es lo que se pidió.

   POR QUÉ EMPIEZA MUTEADO
   No es una preferencia: ningún navegador deja que un video con sonido arranque
   solo. Si no está muteado, `play()` es rechazado y no se ve nada. El botón de
   sonido existe porque el gesto de la persona sí habilita el audio.

   SI ALGO FALLA
   Autoplay bloqueado, `play()` rechazado, `prefers-reduced-motion`, el ahorro
   de datos del teléfono prendido, una conexión 2G, un archivo que no carga: en
   todos esos casos se muestran los controles nativos y el video queda ahí, con
   su póster, para que lo reproduzca quien quiera. Nunca queda un recuadro negro
   sin explicación, y nunca se baja un video que la persona no pidió.
   ────────────────────────────────────────────────────────────────────────── */

(function () {
  var cajas = document.querySelectorAll('[data-nma-video]');
  if (!cajas.length) return;

  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Ahorro de datos del sistema, o una red lenta de verdad. Bajar 2 MB de video
     decorativo ahí es maltratar a la persona: se deja a mano. */
  function redAusteria() {
    var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!con) return false;
    if (con.saveData) return true;
    return /(^|-)2g$/.test(con.effectiveType || '');
  }

  var austera = redAusteria();

  cajas.forEach(function (caja) {
    var video = caja.querySelector('video');
    var boton = caja.querySelector('[data-nma-video-sonido]');
    if (!video) return;

    /* En iOS, sin playsinline el video se abre en pantalla completa al
       reproducirse. Se fuerza acá por si faltara en el HTML. */
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    var cargado = false;

    function rendirse() {
      /* Deja el video utilizable a mano y saca el botón de sonido, que con los
         controles nativos a la vista sería un segundo control para lo mismo.
         No se fuerza ninguna descarga: el póster ya está y el archivo se baja
         solo si la persona le da play. */
      caja.classList.add('is-manual');
      video.controls = true;
      if (boton) boton.hidden = true;
    }

    /* Con JavaScript andando los controles nativos sobran: manda el botón del
       parlante. Vienen puestos desde el HTML justamente para el caso contrario. */
    video.controls = false;

    video.addEventListener('error', rendirse);

    /* ── Elegir la versión del archivo ────────────────────────────────────
       Se llama recién cuando hay que bajar algo, no antes: así la caja ya está
       medida y el ancho es el real, no una estimación. */
    function elegirFuente() {
      /* Safari/iOS: el `<source>` HLS que va primero en el HTML ya ajusta la
         calidad a la red por su cuenta. Tocarlo sería empeorarlo. */
      if (
        video.canPlayType('application/vnd.apple.mpegurl') &&
        video.querySelector('source[type*="mpegurl"]')
      ) {
        return;
      }

      var crudo = video.getAttribute('data-nma-fuentes');
      if (!crudo) return;

      var fuentes;
      try {
        fuentes = JSON.parse(crudo);
      } catch (e) {
        return;
      }
      if (!fuentes || fuentes.length < 2) return; // una sola versión: nada que elegir

      /* Píxeles reales que ocupa la caja. El DPR se corta en 2: pedir el triple
         de resolución en un teléfono de pantalla densa no se nota y pesa. */
      var ancho = caja.getBoundingClientRect().width;
      if (!ancho) return;
      var necesario = ancho * Math.min(window.devicePixelRatio || 1, 2);

      /* La lista viene ordenada de menor a mayor desde Liquid: la primera que
         cubra lo que se ve, y si ninguna llega, la más grande. */
      var elegida = fuentes[fuentes.length - 1];
      for (var i = 0; i < fuentes.length; i++) {
        if (fuentes[i].w >= necesario) {
          elegida = fuentes[i];
          break;
        }
      }

      /* `src` en el elemento gana sobre los `<source>` del HTML. Como todavía
         no se bajó nada (`preload="none"`), reemplazarlo no desperdicia nada. */
      if (elegida && elegida.u) video.src = elegida.u;
    }

    function cargar() {
      if (cargado) return;
      cargado = true;
      elegirFuente();
      video.preload = 'auto';
      video.load();
    }

    if (menosMovimiento || austera) {
      rendirse();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      rendirse();
      return;
    }

    var visible = false;

    function reproducir() {
      cargar();

      /* Con `preload="none"` el archivo empieza a bajar recién en `cargar()`.
         Si en ese mismo instante se pide `play()` —pasa cuando alguien recarga
         la página con la sección ya en pantalla— se le está pidiendo al
         navegador que reproduzca algo que todavía no existe, y hay navegadores
         que rechazan la promesa. Como el rechazo acá significa "autoplay
         bloqueado", el video terminaba con los controles a la vista sin que
         nadie lo hubiera bloqueado. Se espera al primer cuadro y se vuelve. */
      if (video.readyState < 2) {
        video.addEventListener(
          'loadeddata',
          function () {
            if (visible && !document.hidden) reproducir();
          },
          { once: true }
        );
        return;
      }

      var intento = video.play();
      if (intento && typeof intento.catch === 'function') {
        intento.catch(function () {
          /* El navegador bloqueó la reproducción automática. */
          rendirse();
        });
      }
    }

    /* Etapa 1: faltan 300 px para que la sección asome. Se empieza a bajar el
       archivo ahí para que cuando entre en cuadro ya esté listo, sin el segundo
       de negro del principio. */
    var cercano = new IntersectionObserver(
      function (entradas) {
        if (!entradas[0].isIntersecting) return;
        cargar();
        cercano.disconnect();
      },
      { rootMargin: '300px 0px' }
    );
    cercano.observe(caja);

    /* Etapa 2: 40% del bloque a la vista. Arranca cuando la sección es el foco
       de la pantalla, no cuando asoma un borde. */
    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible && !document.hidden) reproducir();
          else video.pause();
        });
      },
      { threshold: 0.4 }
    );
    observador.observe(caja);

    /* Un video corriendo en una pestaña de fondo gasta batería sin que nadie
       lo vea. IntersectionObserver no se entera de un cambio de pestaña. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause();
      else if (visible) reproducir();
    });

    if (!boton) return;

    boton.addEventListener('click', function () {
      video.muted = !video.muted;
      boton.setAttribute('aria-pressed', String(!video.muted));
      boton.setAttribute(
        'aria-label',
        video.muted ? boton.dataset.activar : boton.dataset.silenciar
      );
      /* Si estaba pausado —volvió a la sección justo al tocar— el clic de la
         persona es gesto suficiente para arrancarlo con sonido. */
      if (video.paused && visible) reproducir();
    });
  });
})();
